import * as a from '@mitranim/js/all.mjs'
import * as u from './util.mjs'
import * as d from './dat.mjs'
import * as en from './env.mjs'

export class Ctx extends a.Ctx {
  constructor(env, rou) {
    a.reqInst(env, en.Env)
    a.reqInst(rou, a.ReqRou)

    super(rou.req.signal)

    // Must be private to avoid accidental deinit.
    a.priv(this, `env`, env)

    // Router for current route. Contains info such as request, headers,
    // captured URL parameters, etc.
    this.rou = rou

    // Data-fetching cache. Data is discarded when changing URL/page/context.
    this.pageDat = new d.PageDat(this)

    // Sequencer for generating DOM ids (for inputs, etc.). Currently not
    // actually sequential for technical reasons related to the hybrid SSR/SPA
    // nature of our app.
    this.seq = new u.Seq()
  }

  get dat() {return this.env.dat}
  get langs() {return this.env.langs}
  get lang() {return this.env.lang}
  get baseUrl() {return this.env.baseUrl}
  get headers() {return this.env.headers}

  get url() {return this.rou.url}
  get params() {return a.laxRec(this.rou.groups)}

  fetch(opt) {return u.ctxFetch(this, opt)}
  buk() {return this.pageDat.buk}
  bank() {return this.env.disk.bank()}
  sub() {return new SubCtx(this)}
  xlnImport(mod) {return u.imp(u.xlnImport(mod, this.lang))}

  // Used for SSR-to-client data transfer.
  initData(src) {
    if (!a.optRec(src)) return
    const {buk, user} = src
    if (buk) this.pageDat.buk.mut(buk)
    if (user) this.dat.user.setValue(user)
  }
}

/*
Sub-context for cancellation purposes. Canceling the super-context also cancels
the sub-context. Canceling the sub-context does NOT cancel the super-context.
*/
export class SubCtx extends a.Ctx {
  constructor(ctx) {
    super(a.reqInst(ctx, a.Ctx).signal)

    // Must be private to avoid accidental deinit.
    a.priv(this, `ctx`, ctx)

    // Must be symmetric with `Ctx..pageDat`.
    this.pageDat = new d.PageDat(this)
  }

  get env() {return this.ctx.env}
  get baseUrl() {return this.ctx.baseUrl}
  get headers() {return this.env.headers}
  get dat() {return this.ctx.dat}
  get rou() {return this.ctx.rou}
  get url() {return this.ctx.url}
  get lang() {return this.ctx.lang}
  get seq() {return this.ctx.seq}
  sub() {return new SubCtx(this)}
  buk() {return this.pageDat.buk}
  fetch(opt) {return u.ctxFetch(this, opt)}
}
